import styled from "styled-components";
import { useState, useEffect } from "react";
import PrimaryButton from "../../../../components/FormControls/PrimaryButton";
import SecondaryButton from "../../../../components/FormControls/SecondaryButton";
import request from "../../../../api/request";
import Grid2Groups from "../../../../components/Grid2Groups";
import FormStringInput from "../../../../components/FormControls/FormStringInput";
import FormSelectWithLabel from "../../../../components/FormControls/FormSelectWithLabel";
import FormNumberInputNoSpinner from "../../../../components/FormControls/FormNumberInputNoSpinner";
import FormCheckBoxWithRightLabel from "../../../../components/FormControls/FormCheckBoxWithRightLabel";
import { NotificationManager } from 'react-notifications';
import FormDatePicker from "../../../../components/FormControls/FormDatePicker";
import BalanceOpeningPage from "..";

const StyledBankReconciliationBalances = styled.div`
`;

const WhiteBoard = styled.div`
    background-color: white;
    width: 1000px;
    box-sizing: border-box;
    min-height: 526px;
    padding: 30px;
    margin-bottom: 30px;
    color: ${(props) => props.theme.color.gray};
`;

function BankReconciliationBalances(props) {

    let currentYear = new Date().getFullYear();

    const [loadedPage, setLoadedPage] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [balances, setBalances] = useState([]);
    const [branches, setBranches] = useState([]);
    const [selectedBalance, setSelectedBalance] = useState(null);
    const [selectedBalanceId, setSelectedBalanceId] = useState(null);
    const [isAddBalanceMode, setIsAddBalanceMode] = useState(false);
    const [gridColumns, setGridColumns] = useState([
        {id: 'Division Code', type: 'String', width: 100, textAlign: 'left'},
        {id: 'Bank', type: 'String', width: 65, textAlign: 'center'},
        {id: 'Receipt / payment', type: 'String', width: 140, textAlign: 'left'},
        {id: 'Cheque', type: 'String', width: 125, textAlign: 'center'},
        {id: 'Amount ', type: 'String', width: 130, textAlign: 'right'},
    ]);
    const [gridData, setGridData] = useState({groups: [{name: 'Type: Branches', subGroups: []}, {name: 'Type: Sub-branches', subGroups: []}], items: [[[]], [[]]]});


    const [recordType, setRecordType] = useState(1);
    const [accountingYear, setAccountingYear] = useState(props.baseYear);
    const [branchCommitteeCode, setBranchCommitteeCode] = useState('');
    const [recordName, setRecordName] = useState('');
    const [fundTypeCode, setFundTypeCode] = useState('B');
    const [receiptPayment, setReceiptPayment] = useState(1);
    const [bankCode, setBankCode] = useState('');
    const [transactionDate, setTransactionDate] = useState(null);
    const [amount, setAmount] = useState('0.00');
    const [chequePaymentReference, setChequePaymentReference] = useState('');
    const [canExport, setCanExport] = useState(true);
    const [payeePayer, setPayeePayer] = useState('');
    
    const [branchNames, setBranchNames] = useState([]);
    const [needsValidation, setNeedsValidation] = useState(false);
    const [isAddingDuplicatedBalance, setIsAddingDuplicatedBalance] = useState(false);
    
    const convertDateToUTCTimeZone = (val) => {
        let diffMinutes = val.getTimezoneOffset();
        val.setTime(val.getTime() - diffMinutes*60*1000);
        return val;
    }

    const strToDate = (str) => {
        var date_components = str.split("/");
        var day = date_components[0];
        var month = date_components[1];
        var year = date_components[2];
        return new Date(year, month - 1, day);
    }

    let branchTypes = ['Branch', 'Sub-Branch'];
    const branchTypeStringToInt = (branchTypeStr) => {
        if (branchTypeStr === 'Branch') {
            return 1;
        } else {
            return 2;
        }
    }

    let receiptPaymentStrings = ['Receipt', 'Payment'];
    const receiptPaymentStringToInt = (str) => {
        if (str === 'Receipt') {
            return 1;
        } else {
            return 2;
        }
    }
    const onChangeReceiptPayment = (e) => {
        let type = receiptPaymentStringToInt(e.target.value);
        setReceiptPayment(type);
    }

    const branchNameFromBranchCommitteeCode = (recordType, branchCommitteeCode, divisionCode) => {
        let branchName = '';
        for (let i = 0; i < branches.length; i ++) {
            if (branches[i].RecordType === recordType && branches[i].BranchCommitteeCode === branchCommitteeCode && branches[i].DivisionCode === divisionCode) {
                branchName = branches[i].RecordName;
                break;
            }
        }
        return branchName;
    }

    const branchCommitteeCodeFromBranchName = (recordType, branchName) => {
        let branchCommitteeCode = '';
        for (let i = 0; i < branches.length; i ++) {
            if (branches[i].RecordType === recordType && branches[i].RecordName === branchName) {
                branchCommitteeCode = branches[i].BranchCommitteeCode;
                break;
            }
        }
        return branchCommitteeCode;
    }

    const divisionCodeFromBranchName = (recordType, branchCommitteeCode, branchName) => {
        let divisionCode = '';
        for (let i = 0; i < branches.length; i ++) {
            if (branches[i].RecordType === recordType && branches[i].BranchCommitteeCode === branchCommitteeCode && branches[i].RecordName === branchName) {
                divisionCode = branches[i].DivisionCode;
                break;
            }
        }
        return divisionCode;
    }

    const onChangeRecordType = (e) => {
        let bType = branchTypeStringToInt(e.target.value);
        setRecordType(bType);
    }

    const onChangeBranchName = (e) => {
        setRecordName(e.target.value);
        setBranchCommitteeCode(branchCommitteeCodeFromBranchName(recordType, e.target.value));
    }

    const onSelectGridItem = (item) => {
        setSelectedBalanceId(item.Id);
        setSelectedBalance(item);
    }
    
    const fetchBalances = async (recordTypeToSelect, branchCommitteeCodeToSelect, fundTypeCodeToSelect, bankCodeToSelect, chequePaymentReferenceToSelect) => {
        try {
            let balanceList = [];

            const resp = (await request('database', 'fetchBankReconciliationBalances'));
            if (resp.ok) {
                resp.data.map((balance, index) => {
                    balanceList.push(balance);
                });
                setBalances(balanceList);
                rebuildGridData(balanceList, recordTypeToSelect, branchCommitteeCodeToSelect, fundTypeCodeToSelect, bankCodeToSelect, chequePaymentReferenceToSelect);
            } else {
                console.log(resp.data);
                NotificationManager.error(resp.data);
                return false;
            }
        } catch (e) {
            console.log('Failed to fetch bank reconciliation balances: ', e);
            return false;
        }
        return true;
    }
    
    const fetchBranches = async () => {
        try {
            let branchList = [];

            const resp = (await request('database', 'fetchBranches'));
            if (resp.ok) {
                resp.data.map((branch, index) => {
                    branchList.push(branch);
                });
                setBranches(branchList);
            } else {
                console.log(resp.data);
                NotificationManager.error(resp.data);
                return false;
            }
        } catch (e) {
            console.log('Failed to fetch branches: ', e);
            return false;
        }
        return true;
    }

    const onDeleteBalance = async () => {
        if (selectedBalance) {
            setIsDeleting(true);
            let deleteData = selectedBalance;
            
            const resp = (await request('database', 'deleteBankReconciliationBalance', [deleteData]));
            if (resp.ok) {
                setSelectedBalance(null);
                setSelectedBalanceId(null);
                fetchBalances();
                NotificationManager.success('Successfully deleted balance');
            } else {
                console.log(resp.data);
                NotificationManager.error(resp.data);
            }
            setIsDeleting(false);
        }
    }

    const onSaveChanges = async () => {
        if (isAddBalanceMode) { // adding new item
            if (bankCode === '' || transactionDate === null || chequePaymentReference === '' || payeePayer === '' || isNaN(parseFloat(amount))) {
                setNeedsValidation(true);
            } else {
                // check duplicated code
                if (balances.length > 0 && (balances.find((itm) => itm.RecordType === recordType && itm.AccountingYear === accountingYear && itm.FundTypeCode.replace(/\s/g, '') === fundTypeCode && itm.BranchCommitteeCode === branchCommitteeCode && itm.BankCode.replace(/\s/g, '') === bankCode.replace(/\s/g, '') && itm.ChequePaymentReference === chequePaymentReference))) {
                    setIsAddingDuplicatedBalance(true);
                } else {
                    setIsSaving(true);
                    let saveData = {};
                    saveData.RecordType = recordType;
                    saveData.AccountingYear = accountingYear;
                    saveData.BranchCommitteeCode = branchCommitteeCode;
                    saveData.DivisionCode = divisionCodeFromBranchName(recordType, branchCommitteeCode, recordName);
                    saveData.FundTypeCode = fundTypeCode;
                    saveData.ReceiptPayment = receiptPayment;
                    saveData.BankCode = bankCode;
                    saveData.TransactionDate = convertDateToUTCTimeZone(transactionDate);
                    saveData.Amount = floatToString(parseFloat(amount));
                    saveData.ChequePaymentReference = chequePaymentReference;
                    saveData.PayeePayer = payeePayer;
                    saveData.CanExport = canExport;

                    const resp = (await request('database', 'createBankReconciliationBalance', [saveData]));
                    if (resp.ok) {
                        fetchBalances(recordType, branchCommitteeCode, fundTypeCode, bankCode, chequePaymentReference);
                        NotificationManager.success('Successfully added balance');
                    } else
                    {
                        console.log(resp.data);
                        NotificationManager.error(resp.data);
                    }
                    setIsSaving(false);
                    setIsAddBalanceMode(false);
                }
            }
        } else {
            if (bankCode === '' || transactionDate === null || chequePaymentReference === '' || payeePayer === '' || isNaN(parseFloat(amount))) {
                setNeedsValidation(true);
            } else {
                // check duplicated code
                if (balances.length > 0 && (balances.find((itm) => (itm.RecordType !== selectedBalance.RecordType || itm.AccountingYear !== selectedBalance.AccountingYear || itm.FundTypeCode !== selectedBalance.FundTypeCode || itm.BranchCommitteeCode !== selectedBalance.BranchCommitteeCode || itm.BankCode.replace(/\s/g, '') !== selectedBalance.BankCode.replace(/\s/g, '') || itm.ChequePaymentReference !== selectedBalance.ChequePaymentReference) && itm.RecordType === recordType && itm.AccountingYear === accountingYear && itm.FundTypeCode.replace(/\s/g, '') === fundTypeCode && itm.BranchCommitteeCode === branchCommitteeCode && itm.BankCode.replace(/\s/g, '') === bankCode.replace(/\s/g, '') && itm.ChequePaymentReference === chequePaymentReference))) {
                    setIsAddingDuplicatedBalance(true);
                } else {
                    setIsSaving(true);
                    let saveData = {};
                    saveData.RecordType = recordType;
                    saveData.AccountingYear = accountingYear;
                    saveData.BranchCommitteeCode = branchCommitteeCode;
                    saveData.DivisionCode = divisionCodeFromBranchName(recordType, branchCommitteeCode, recordName);
                    saveData.FundTypeCode = fundTypeCode;
                    saveData.ReceiptPayment = receiptPayment;
                    saveData.BankCode = bankCode;
                    saveData.TransactionDate = convertDateToUTCTimeZone(transactionDate);
                    saveData.Amount = floatToString(parseFloat(amount));
                    saveData.ChequePaymentReference = chequePaymentReference;
                    saveData.PayeePayer = payeePayer;
                    saveData.CanExport = canExport;

                    saveData.OldRecordType = selectedBalance.RecordType;
                    saveData.OldAccountingYear = selectedBalance.AccountingYear;
                    saveData.OldBranchCommitteeCode = selectedBalance.BranchCommitteeCode;
                    saveData.OldFundTypeCode = selectedBalance.FundTypeCode;
                    saveData.OldDivisionCode = selectedBalance.DivisionCode;
                    saveData.OldBankCode = selectedBalance.BankCode;
                    saveData.OldReceiptPayment = selectedBalance.ReceiptPayment;
                    saveData.OldChequePaymentReference = selectedBalance.ChequePaymentReference;

                    const resp = (await request('database', 'updateBankReconciliationBalance', [saveData]));
                    if (resp.ok) {
                        fetchBalances(recordType, branchCommitteeCode, fundTypeCode, bankCode, chequePaymentReference);
                        NotificationManager.success('Successfully updated balance');
                    } else
                    {
                        console.log(resp.data);
                        NotificationManager.error(resp.data);
                    }
                    setIsSaving(false);
                    setIsAddBalanceMode(false);
                }
            }
        }
    }

    const floatToString = (val) => {
        return val.toFixed(2);
    }

    const rebuildGridData = (balances, recordTypeToSelect, branchCommitteeCodeToSelect, fundTypeCodeToSelect, bankCodeToSelect, chequePaymentReferenceToSelect) => {
        if (balances && balances.length > 0) {
            let branchBalances = [];
            let subBranchBalances = [];
            let branchNameStringsForBranch = [];
            let branchNameStringsForSubBranch = [];
            let prevBranchCommitteeCode = null;
            let subArrBranches = [];
            let subArrSubBranches = [];

            let selectGridItem;
            let selectGridItemId;

            balances.sort((a,b) => {return a.BranchCommitteeCode < b.BranchCommitteeCode ? -1 : 1}).map((balance, index) => {
                if (balance.AccountingYear === props.baseYear) {
                    let gridItem = {Id: index,
                                    'Division Code': balance.DivisionCode,
                                    'Bank': balance.BankCode.replace(/\s/g, ''),
                                    'Receipt / payment': receiptPaymentStrings[balance.ReceiptPayment - 1],
                                    Cheque: balance.ChequePaymentReference ? balance.ChequePaymentReference : '',
                                    'Amount ': floatToString(balance.Amount),
                                    ...balance};
                    if (balance.BranchCommitteeCode !== prevBranchCommitteeCode) {
                        if (prevBranchCommitteeCode !== null) {
                            if (subArrBranches.length > 0) {
                                branchBalances.push(structuredClone(subArrBranches));
                                subArrBranches.splice(0, subArrBranches.length);
                            }
                            if (subArrSubBranches.length > 0) {
                                subBranchBalances.push(structuredClone(subArrSubBranches));
                                subArrSubBranches.splice(0, subArrSubBranches.length);
                            }
                        }
                        if (balance.RecordType === 1) {
                            branchNameStringsForBranch.push(balance.BranchCommitteeCode + " - " + branchNameFromBranchCommitteeCode(balance.RecordType, balance.BranchCommitteeCode, balance.DivisionCode));
                        } else {
                            branchNameStringsForSubBranch.push(balance.BranchCommitteeCode + " - " + branchNameFromBranchCommitteeCode(balance.RecordType, balance.BranchCommitteeCode, balance.DivisionCode));
                        }

                        prevBranchCommitteeCode = balance.BranchCommitteeCode;
                    }
                    if (balance.RecordType === 1) {
                        subArrBranches.push(gridItem);
                    } else {
                        subArrSubBranches.push(gridItem);
                    }
                    if (recordTypeToSelect && branchCommitteeCodeToSelect && fundTypeCodeToSelect && bankCodeToSelect && chequePaymentReferenceToSelect && balance.RecordType === recordTypeToSelect && balance.BranchCommitteeCode === branchCommitteeCodeToSelect && balance.FundTypeCode.replace(/\s/g, '') === fundTypeCodeToSelect.replace(/\s/g, '') && balance.BankCode.replace(/\s/g, '') === bankCodeToSelect.replace(/\s/g, '') && balance.ChequePaymentReference === chequePaymentReferenceToSelect) {
                        selectGridItem = gridItem;
                        selectGridItemId = index;
                    }
                }
            });
            if (subArrBranches.length > 0) {
                branchBalances.push(structuredClone(subArrBranches));
            }
            if (subArrSubBranches.length > 0) {
                subBranchBalances.push(structuredClone(subArrSubBranches));
            }
            setGridData({groups: [{name: 'Type: Branches', subGroups: branchNameStringsForBranch}, {name: 'Type: Sub-branches', subGroups: branchNameStringsForSubBranch}], items: [branchBalances, subBranchBalances]});
            setSelectedBalanceId(selectGridItemId);
            setSelectedBalance(selectGridItem);
        }
    }

    useEffect(() => {
        if (!loadedPage) {
            fetchBalances();
            fetchBranches();
            setLoadedPage(true);
        }
        rebuildGridData(balances);

        setRecordType(1);
        setAccountingYear(props.baseYear);
        if (branches.length > 0) {
            let b = branches.find((itm) => itm.RecordType === 1);
            setBranchCommitteeCode(b.BranchCommitteeCode);
            setRecordName(b.RecordName);
        } else {
            setBranchCommitteeCode('');
            setRecordName('None');
        }
        setFundTypeCode('B');
        setBankCode('');
        setTransactionDate(null);
        setAmount('0.00');
        setChequePaymentReference('');
        setPayeePayer('');
        setCanExport(true);
        setSelectedBalance(null);
        setSelectedBalanceId(null);
        setNeedsValidation(false);
    }, [props.baseYear, branches]);

    useEffect(() => {
        if (isAddBalanceMode) {
            setNeedsValidation(false);
            setRecordType(1);
            setAccountingYear(props.baseYear);
            if (branches.length > 0) {
                let b = branches.find((itm) => itm.RecordType === 1);
                setBranchCommitteeCode(b.BranchCommitteeCode);
                setRecordName(b.RecordName);
            } else {
                setBranchCommitteeCode('');
                setRecordName('None');
            }
            setFundTypeCode('B');
            setBankCode('');
            setTransactionDate(null);
            setAmount('0.00');
            setChequePaymentReference('');
            setPayeePayer('');
            setCanExport(true);
        } else if (selectedBalance) {
            setNeedsValidation(false);
            setRecordType(selectedBalance.RecordType);
            setAccountingYear(selectedBalance.AccountingYear);
            if (branches.length > 0) {
                let b = branches.find((itm) => itm.RecordType === selectedBalance.RecordType && itm.BranchCommitteeCode === selectedBalance.BranchCommitteeCode && itm.DivisionCode === selectedBalance.DivisionCode);
                if (b) {
                    setBranchCommitteeCode(b.BranchCommitteeCode);
                    setRecordName(b.RecordName);
                } else {
                    setBranchCommitteeCode('');
                    setRecordName('None');
                }
            } else {
                setBranchCommitteeCode('');
                setRecordName('None');
            }
            setFundTypeCode(selectedBalance.FundTypeCode);
            setBankCode(selectedBalance.BankCode);
            setTransactionDate(new Date(selectedBalance.TransactionDate));
            setAmount(floatToString(selectedBalance.Amount));
            setChequePaymentReference(selectedBalance.ChequePaymentReference ? selectedBalance.ChequePaymentReference : '');
            setPayeePayer(selectedBalance.PayeePayer ? selectedBalance.PayeePayer : '');
            setCanExport(selectedBalance.CanExport);
        }
    }, [isAddBalanceMode]);

    useEffect(() => {
        setIsAddingDuplicatedBalance(false);
    }, [accountingYear, fundTypeCode, bankCode, chequePaymentReference, payeePayer]);

    useEffect(() => {
        setIsAddingDuplicatedBalance(false);
        setNeedsValidation(false);
    }, [props.baseYear, selectedBalance, isAddBalanceMode]);

    useEffect(() => {
        setIsAddingDuplicatedBalance(false);

        let branchNameList = [];
        let isRefreshedBranchName = false;
        branches.map((b, idx) => {
            if (b.RecordType === recordType) {
                branchNameList.push(b.RecordName);
                if (!isRefreshedBranchName) {
                    if (isAddBalanceMode || (selectedBalance && selectedBalance.RecordType !== recordType)) {
                        setBranchCommitteeCode(b.BranchCommitteeCode);
                        setRecordName(b.RecordName);
                    } else if (selectedBalance && selectedBalance.RecordType === recordType) {
                        setBranchCommitteeCode(selectedBalance.BranchCommitteeCode);
                        setRecordName(branchNameFromBranchCommitteeCode(selectedBalance.RecordType, selectedBalance.BranchCommitteeCode, selectedBalance.DivisionCode));
                    }
                    isRefreshedBranchName = true;
                }
            }
        });
        setBranchNames(branchNameList)
    }, [branches, recordType]);

    useEffect(() => {
        if (selectedBalance) {
            setRecordType(selectedBalance.RecordType);
            setAccountingYear(selectedBalance.AccountingYear);
            if (branches.length > 0) {
                let b = branches.find((itm) => itm.RecordType === selectedBalance.RecordType && itm.BranchCommitteeCode === selectedBalance.BranchCommitteeCode && itm.DivisionCode === selectedBalance.DivisionCode);
                if (b) {
                    setBranchCommitteeCode(b.BranchCommitteeCode);
                    setRecordName(b.RecordName);
                } else {
                    setBranchCommitteeCode('');
                    setRecordName('None');
                }
            } else {
                setBranchCommitteeCode('');
                setRecordName('None');
            }
            setFundTypeCode(selectedBalance.FundTypeCode.replace(/\s/g, ''));
            setBankCode(selectedBalance.BankCode);
            setTransactionDate(new Date(selectedBalance.TransactionDate));
            setAmount(floatToString(selectedBalance.Amount));
            setChequePaymentReference(selectedBalance.ChequePaymentReference ? selectedBalance.ChequePaymentReference : '');
            setPayeePayer(selectedBalance.PayeePayer ? selectedBalance.PayeePayer : '');
            setCanExport(selectedBalance.CanExport);
        } else {
            setNeedsValidation(false);
            setRecordType(1);
            setAccountingYear(props.baseYear);
            if (branches.length > 0) {
                let b = branches.find((itm) => itm.RecordType === 1);
                setBranchCommitteeCode(b.BranchCommitteeCode);
                setRecordName(b.RecordName);
            } else {
                setBranchCommitteeCode('');
                setRecordName('None');
            }
            setFundTypeCode('B');
            setBankCode('');
            setTransactionDate(null);
            setAmount('0.00');
            setChequePaymentReference('');
            setPayeePayer('');
            setCanExport(true);
        }
    }, [selectedBalance]);

    return (
        <StyledBankReconciliationBalances>
            <WhiteBoard>
                <div style={{display:'flex'}}>
                    <div>
                        <Grid2Groups id='bank_unreconciliate_balance_grid' gridColumns={gridColumns} gridData={gridData} disabled={isAddBalanceMode} itemIdToSelect={selectedBalanceId} onSelectGridItem={onSelectGridItem} gridStyle={{width:560, height:400}}></Grid2Groups>
                        <div style={{marginTop:20}}>
                            {selectedBalance && !isAddBalanceMode && <SecondaryButton caption='Delete' isLoading={isDeleting} onClick={() => onDeleteBalance()} style={{width:75, height:25}}></SecondaryButton>}
                            {isAddBalanceMode && <SecondaryButton caption='Cancel' onClick={() => setIsAddBalanceMode(false)} style={{width:75, height:25, float:'right'}}></SecondaryButton>}
                            {!isAddBalanceMode && <PrimaryButton caption='Create new' onClick={() => setIsAddBalanceMode(true)} style={{width:100, height:25, float:'right'}}></PrimaryButton>}
                        </div>
                    </div>
                    <div style={{marginLeft:30}}>
                        <div style={{display:'flex'}}>
                            <FormNumberInputNoSpinner label='Year' value={accountingYear} disabled={!isAddBalanceMode || (selectedBalance && selectedBalance.IsExported)} onChange={(val) => setAccountingYear(val)} inputStyle={{width:100, height:35}} style={{paddingTop:0}}></FormNumberInputNoSpinner>
                            <FormSelectWithLabel label='Type' items={branchTypes} value={branchTypes[recordType-1]} disabled={(!isAddBalanceMode && !selectedBalance) || (selectedBalance && selectedBalance.IsExported)} onChange={(e) => onChangeRecordType(e)} style={{width:220, height:35, paddingLeft:10}} selectStyle={{paddingTop:0, marginLeft:18}}></FormSelectWithLabel>
                        </div>
                        <div style={{display: 'flex'}}>
                            <FormStringInput label='Branch code' value={branchCommitteeCode} disabled={true} inputStyle={{width:100, height:35}}></FormStringInput>
                            <FormSelectWithLabel label='Branch / Sub-branch' items={!isAddBalanceMode && !selectedBalance ? ['None'] : branchNames} value={recordName} disabled={(!isAddBalanceMode && !selectedBalance) || (selectedBalance && selectedBalance.IsExported)} onChange={(e) => onChangeBranchName(e)} style={{width:220, height:35, paddingLeft:10}} selectStyle={{marginLeft:18}}></FormSelectWithLabel>
                        </div>

                        <div style={{display: 'flex', marginTop: 15}}>
                            <FormSelectWithLabel label='Account type' items={!isAddBalanceMode && !selectedBalance ? ['None'] : ['B', 'BF']} value={fundTypeCode} disabled={(!isAddBalanceMode && !selectedBalance) || (selectedBalance && selectedBalance.IsExported)} onChange={(e) => setFundTypeCode(e.target.value)} style={{width:100, height:35, paddingLeft:10}}></FormSelectWithLabel>
                            <FormSelectWithLabel label='Receipt / Payment' items={receiptPaymentStrings} value={receiptPaymentStrings[receiptPayment-1]} disabled={(!isAddBalanceMode && !selectedBalance) || (selectedBalance && selectedBalance.IsExported)} onChange={(e) => onChangeReceiptPayment(e)} style={{width:220, height:35, paddingLeft:10}} selectStyle={{marginLeft:18}}></FormSelectWithLabel>
                        </div>

                        <div style={{display: 'flex'}}>
                            <FormStringInput label='Bank code' value={bankCode} disabled={(!isAddBalanceMode && !selectedBalance) || (selectedBalance && selectedBalance.IsExported)} validated={needsValidation && bankCode === '' ? false : undefined} onChange={(val) => setBankCode(val)} inputStyle={{width:100, height:35}}></FormStringInput>
                            <FormDatePicker label='Transaction date' value={transactionDate} onChange={(val) => setTransactionDate(val)} style={{width:220, marginLeft:18}} validated={needsValidation && transactionDate === null ? false : undefined} disabled={selectedBalance === null && !isAddBalanceMode} ></FormDatePicker>
                        </div>

                        <div style={{marginTop:15}}>
                            <FormStringInput label='Transaction amount' value={amount} disabled={(!isAddBalanceMode && !selectedBalance) || (selectedBalance && selectedBalance.IsExported)} validated={needsValidation && isNaN(parseFloat(amount)) ? false : undefined} onChange={(val) => setAmount(val)} inputStyle={{width:337, height:35}}></FormStringInput>
                        </div>

                        <div style={{display: 'flex'}}>
                            <FormStringInput label='Cheque number' value={chequePaymentReference} disabled={(!isAddBalanceMode && !selectedBalance) || (selectedBalance && selectedBalance.IsExported)} validated={needsValidation && chequePaymentReference === '' ? false : undefined} onChange={(val) => setChequePaymentReference(val)} inputStyle={{width:160, height:35}}></FormStringInput>
                            <FormStringInput label='Payee' value={payeePayer} disabled={(!isAddBalanceMode && !selectedBalance) || (selectedBalance && selectedBalance.IsExported)} validated={needsValidation && payeePayer === '' ? false : undefined} onChange={(val) => setPayeePayer(val)} inputStyle={{width:160, height:35}} style={{marginLeft:18}}></FormStringInput>
                        </div>

                        <FormCheckBoxWithRightLabel label='Export to SkyEnterprise' checked={canExport} disabled={(!isAddBalanceMode && !selectedBalance) || (selectedBalance && selectedBalance.IsExported)} onCheck={(val) => setCanExport(val)}></FormCheckBoxWithRightLabel>
                        
                        {isAddingDuplicatedBalance && <div style={{marginTop:15, width:330, fontSize:12, fontWeight:700, color:'#dc3545'}}>* Cheque number is duplicated.</div>}
                    </div>
                </div>
            </WhiteBoard>
            <div>
                <PrimaryButton caption={isAddBalanceMode ? 'Add new' : 'Save changes'} isLoading={isSaving} onClick={() => onSaveChanges()} disabled={isAddBalanceMode || selectedBalance ? false : true} style={{width:150, float:'right'}}></PrimaryButton>
            </div>
        </StyledBankReconciliationBalances>
    )
}

export default BankReconciliationBalances;